export const COMMISSIONING_POLLING = {
  REFETCH_INTERVAL_MS: 4_000,
  ANALYZING_SCREEN_MS: 15_000,
  ALMOST_SCREEN_MS: 45_000,
} as const
